import {
    Badge,
    Box,
    Card, CardBody, CardHeader, Flex, Heading, Image, LinkBox, LinkOverlay,Tooltip, Text, useColorModeValue,
} from '@chakra-ui/react'
import {FaCheck as CheckIcon} from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import StatusBadge from "../../components/StatusBadge";
const ProjectCard = ({project}) => {
    const navigate = useNavigate();



    return (
            <Card bg={useColorModeValue("gray.50", "gray.700")} h="100%" display="flex" flexDirection="column">
                <LinkBox >
                    <CardHeader px={4} pt={4} pb={0}>
                        <LinkOverlay href={"/workspace/" + project.id} />
                        <Image
                            src={project.image_url}
                            alt={`Image for ${project.name}`}
                            // maxHeight="200px" // Set a maximum height for the image
                            height={"150px"}
                            objectFit="fill"// Ensure the aspect ratio is maintained
                            width="100%"
                            borderRadius="md"
                        />
                    </CardHeader>
                </LinkBox>

                <CardBody flexGrow={1} p={4}>
                    <Flex flexDirection={"column"} gap={2} h="100%">
                        <StatusBadge status={project.status} region={project.region}/>
                        <Heading fontSize="xl" isTruncated>{project.name}</Heading>
                        <Tooltip textAlign={"justify"} key={project.id} label={project.description} placement="auto-start" hasArrow>
                            <Text noOfLines={4} flex={1} align="justify">
                                {project.description}
                            </Text>
                        </Tooltip>
                    </Flex>
                </CardBody>
            </Card>
    )
};

export default ProjectCard;